import { modalStyleForm } from "../../../../utils/constant";
import lodash from "lodash";
import { addModal } from "../../../../app.logic";
import i18n from "../../../../i18n";

export const onPreview = ({ file, data }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            title: () => file?.name,
            width: "520px",
            cancelText: i18n.global.t("button.close"),
            okButtonProps: { style: {"display": "none"} },
            onOk: () => {
                options.bind.onCancel();
            }
        }),
        render: () => {
            console.log("file", file)
            console.log("datadata", data)
            const img = !file?.type?.includes?.("image/") ? <div>Cannot Preview</div>
                : file?.blob && file?.type && file?.name ? <img className="w-100" src={`data:${file.type};base64,${file.blob}`} alt={file.name}/>
                : file?.url ? <img class="w-100" src={file.url} alt={file.name} />
                : <div>Cannot Preview</div>;
            return <div>{img}</div>
        }
    });
};